module.exports = __webpack_public_path__ + "static/media/unchecked.2d2292ac.svg";